module.exports = __webpack_public_path__ + "static/media/clubhouse.be070fb6.png";